"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/http");
var platform_browser_1 = require("@angular/platform-browser");
var forms_1 = require("@angular/forms");
require("rxjs/add/operator/distinctUntilChanged");
require("rxjs/add/operator/filter");
require("rxjs/add/operator/mergeMap");
var blockies = require("blockies");
var shared_1 = require("./shared");
var AppComponent = /** @class */ (function () {
    function AppComponent(betTokenNetwork, betTokenService, http, domSanitizer, changeDetectorRef) {
        this.betTokenNetwork = betTokenNetwork;
        this.betTokenService = betTokenService;
        this.http = http;
        this.domSanitizer = domSanitizer;
        this.changeDetectorRef = changeDetectorRef;
        this.newBet = {};
        this.newTransfer = {};
        this.openedBet = undefined;
    }
    AppComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.connected$ = this.betTokenService.connectedChange$;
        this.ethBalance$ = this.betTokenService.getEthBalanceChanges();
        this.balance$ = this.betTokenService.getBalanceChanges();
        this.debt$ = this.betTokenService.getDebtChanges();
        this.myBets$ = this.betTokenService.getMyBetsChanges().map(function (bets) {
            if (bets === void 0) { bets = []; }
            return bets.reverse();
        });
        this.availableBalance$ = this.betTokenService.getAvailableBalanceChanges();
        this.pendingTransactions$ = this.betTokenService.getPendingTransactionsChanges();
        this.transfers$ = this.betTokenService.getMyTransfersChanges();
        this.betTokenService
            .getToken()
            .subscribe(function (token) { return _this.token = token; });
        this.betTokenService
            .getAccountChanges()
            .subscribe(function (account) { return _this.account = account; });
        this.betTokenService
            .getEthBalanceChanges()
            .filter(function (balance) { return balance === 0; })
            .mergeMap(function () { return _this.betTokenService.getAccount(); })
            .distinctUntilChanged()
            .mergeMap(function (account) {
            return _this.betTokenService
                .getNetwork()
                .filter(function (network) { return network === 'ropsten'; })
                .map(function () { return account; });
        })
            .subscribe(function (account) { return _this.claimTestEtherOnRopsten(account); });
    };
    AppComponent.prototype.claimTestEtherOnRopsten = function (account) {
        console.log('Donete to ', account);
        this.http.post('https://faucet.metamask.io', account)
            .subscribe(function () { return console.log('Donation done!'); });
    };
    AppComponent.prototype.getImageOf = function (account) {
        if (account === void 0) { account = ''; }
        return this.domSanitizer.bypassSecurityTrustStyle("url(" + blockies({ seed: account.toLowerCase(), size: 8, scale: 8 }).toDataURL() + ")");
    };
    AppComponent.prototype.dripToMe = function () {
        this.betTokenService
            .dripToMe()
            .subscribe();
    };
    AppComponent.prototype.createBet = function () {
        var _this = this;
        var _a = this.newBet, against = _a.against, amount = _a.amount, bet = _a.bet;
        this.betTokenService
            .createBet(against, amount, bet)
            .subscribe(function () {
            _this.newBetForm.reset();
            _this.creatingBet = false;
            _this.changeDetectorRef.markForCheck();
        }, function () {
            _this.creatingBet = false;
            _this.changeDetectorRef.markForCheck();
        });
        this.creatingBet = true;
    };
    AppComponent.prototype.transfer = function () {
        var _this = this;
        var _a = this.newTransfer, to = _a.to, amount = _a.amount;
        this.betTokenService
            .transfer(to, amount)
            .subscribe(function () {
            _this.newTransferForm.reset();
            _this.creatingTransfer = false;
            _this.changeDetectorRef.markForCheck();
        }, function () {
            _this.creatingTransfer = false;
            _this.changeDetectorRef.markForCheck();
        });
        this.creatingTransfer = true;
    };
    AppComponent.prototype.accept = function (bet, accept) {
        this.betTokenService
            .acceptBet(bet.id, accept)
            .subscribe();
    };
    AppComponent.prototype.giveMeTheMoney = function (bet) {
        this.betTokenService
            .giveMeTheMoney(bet.id)
            .subscribe();
    };
    AppComponent.prototype.cryAndForgotBet = function (bet) {
        this.betTokenService
            .cryAndForgotBet(bet.id)
            .subscribe();
    };
    AppComponent.prototype.trackBet = function (index, bet) {
        return String(bet.id) || '';
    };
    AppComponent.prototype.trackTransaction = function (index, tx) {
        return String(tx.hash) || '';
    };
    AppComponent.prototype.trackTransfer = function (index, transfer) {
        return String(transfer.tx) || '';
    };
    AppComponent.prototype.reload = function () {
        window.location.reload();
    };
    return AppComponent;
}());
exports.AppComponent = AppComponent;



// WEBPACK FOOTER //
// /home/travis/build/Pedro-vk/Bet-Token-wallet/src/app/app.component.ts.pre-build-optimizer.js